<template>
    <div>
        <div id="login_welcome">
            <div id="new_password_icon"></div>
            <div id="login_welcome_message">{{ $t('Your password has expired and must be changed') }}</div>
        </div>
        <div id="login_content">
            <ul id="login_credentials">
                <li>
                    <label class="login-label">{{ $t('New Password') }}</label>
                    <cic-textbox
                        id="newpassword"
                        :value="newPassword"
                        type="password"
                        @keyup.enter="login"
                        @input="(val) => (newPassword = val)"
                    />
                    <label class="login-explain">{{ $t('Enter a new password') }}</label>
                </li>
                <li>
                    <label class="login-label">{{ $t('Re-enter New Password') }}</label>
                    <cic-textbox
                        id="newpassword2"
                        :value="newPassword2"
                        type="password"
                        @keyup.enter="login"
                        @input="(val) => (newPassword2 = val)"
                    />
                    <label class="login-explain">{{ $t('Confirm your new password') }}</label>
                </li>
            </ul>

            <div class="cic-control-bar">
                <cic-button class="ok" @click="login">
                    {{ $t('Confirm') }}
                </cic-button>
            </div>
        </div>
    </div>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'ChangePassword',
        components: {
            CicButton,
            CicTextbox,
        },
        emits: ['change'],
        data() {
            return {
                newPassword: null,
                newPassword2: null,
            };
        },
        methods: {
            login() {
                this.$emit('change', this.newPassword, this.newPassword2);
            },
        },
    };
</script>
